export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m20 14-2.29 2.29-2.88-2.88-1.42 1.42 2.88 2.88L14 20h6m0-10V4h-6l2.29 2.29-4.7 4.71H4v2h8.41l5.3-5.29\"/>"
};